import { countAllocationDays } from "./dayMath";
import { round2 } from "./aggregates";

/** The pointer must move this many px before a press on a bar is a drag and not a click. */
export const DRAG_THRESHOLD = 3;

/** What part of a bar the user is dragging: its body moves it, its edges change one end. */
export const DragType = { MOVE: "move", RESIZE_LEFT: "left", RESIZE_RIGHT: "right" };

/**
 * The days a bar covers after the pointer moved `dx` px, snapped to whole days. Moving shifts both ends; resizing
 * moves one end and stops at the other, so a bar always keeps at least one day. The timeline limits how far it goes.
 *
 * @returns { startDay, endDay }
 */
export function resolveDrag({ type, startDay, endDay, dx, dayWidth, timeline }) {
  const shift = Math.round(dx / dayWidth);

  if (type === DragType.RESIZE_LEFT) {
    return { startDay: Math.max(timeline.originDay, Math.min(startDay + shift, endDay)), endDay };
  }
  if (type === DragType.RESIZE_RIGHT) {
    return { startDay, endDay: Math.min(timeline.lastDay, Math.max(endDay + shift, startDay)) };
  }

  const length = endDay - startDay;
  const movedStart = Math.min(timeline.lastDay - length, Math.max(timeline.originDay, startDay + shift));
  return { startDay: movedStart, endDay: movedStart + length };
}

/** Hours an allocation has over some days at its hours per day. */
export function previewHours(allocation, startDay, endDay) {
  const days = countAllocationDays(startDay, endDay, allocation.includeWeekends);
  return { days, totalHours: round2(days * allocation.hoursPerDay) };
}
